





































import { Watch, Prop, Component, Vue, Ref } from 'vue-property-decorator'
import { Branch } from '@/api/model/branch'
import { Company } from '@/api/model/company'
import { ProviderInstance } from 'vee-validate/dist/types/types'

@Component
export default class InputMultiSelectBranch extends Vue {
    @Ref() validator!: ProviderInstance
    @Prop({ type: String }) readonly vid!: string
    @Prop({ default: null }) readonly rules!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly branches!: Branch[]
    @Prop() readonly value!: any[]
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    @Prop({ type: Boolean, default: false }) readonly clearable!: boolean
    @Prop({ type: Boolean, default: false }) readonly white!: boolean
    selected: any[] = []
    showOptions: boolean = false

    created() {
        this.onValueChanged()
        window.addEventListener('click', this.onOutsideClick)
    }

    beforeDestroy() {
        window.removeEventListener('click', this.onOutsideClick)
    }

    @Watch('branches')
    onBranchesChanged() {
        this.selected = this.selected.filter(branchId => {
            return this.branches.some((branch: Branch) => branch.id === branchId)
        })
        this.onSelectedChanged()
    }

    @Watch('value')
    onValueChanged() {
        this.selected = []

        if (!this.value) {
            return
        }

        this.value.forEach(v => {
            const option = this.findOptionByValue(v)
            if (option && this.selected.some(s => s === option.id) === false) {
                this.selected.push(option.id)
            }
        })
    }

    onSelectedChanged() {
        this.validator.validate(this.selected)
        this.$emit('input', this.selected.map(selected => {
            return this.branches.find(branch => branch.id === selected)
        }))
    }

    toggleOptions(): void {
        if (!this.disabled) {
            this.showOptions = !this.showOptions
        }
    }

    toggleOption(branchId: string) {
        if (this.disabled) {
            return
        }

        if (this.isSelected(branchId)) {
            this.selected = this.selected.filter(value => value !== branchId)
        } else {
            this.selected.push(branchId)
        }

        this.onSelectedChanged()
    }

    isSelected(branchId: string) {
        return this.selected.includes(branchId)
    }

    findOptionByValue(value: Branch) {
        const branches = this.branches.filter(branch => branch.id === value.id)
        if (branches.length > 0) {
            return branches[0]
        }

        return null
    }

    get isClearable(): boolean {
        return this.clearable && this.selected.length && !this.disabled
    }

    clear(): void {
        this.selected = []
        this.onSelectedChanged()
        this.showOptions = false
    }

    get componentClass(): object {
        return {
            'input-multi-select-branch': true,
            'input-multi-select': true,
            'input-select-branch': true,
            'input-select': true,
            'input-select--disabled': this.disabled,
            'input-select--white': this.white,
        }
    }

    isCurrentCompany(company: Company): boolean {
        return this.$currentCompany.id === company.id
    }

    async onOutsideClick(e: Event) {
        const target = e.target as HTMLDivElement

        if (!this.$el.contains(target)) {
            this.showOptions = false
        }
    }
}
